<template>
    <div class="right">
        <el-row style="width: 390px">
            <el-col :span="18"
                ><div
                    style="
                        text-align: center;
                        width: 293px;
                        height: 48px;
                        background: #ffffff;
                        border-radius: 4px;
                    "
                >
                    <el-col
                        :span="8"
                        :class="[clicklgenddiv ? 'clickdiv' : '']"
                        style="line-height: 48px; cursor: pointer"
                    >
                        <div @click="displayLgend">
                            <el-image
                                style="
                                    width: 16px;
                                    height: 16px;
                                    line-height: 48px;
                                    top: 3px;
                                    right: 5px;
                                "
                                :src="
                                    clicklgenddiv
                                        ? '/static/images/图例-选中.png'
                                        : '/static/images/图例-未选中.png'
                                "
                            ></el-image
                            ><span
                                class="spantext"
                                :class="[clicklgenddiv ? 'clickspan' : '']"
                                >图例</span
                            >
                        </div>
                    </el-col>
                    <el-col
                        :span="8"
                        style="line-height: 48px; cursor: pointer"
                        :class="[clicklayerdiv ? 'clickdiv' : '']"
                    >
                        <div
                            @click="
                                clickflag = false
                                clicklgenddiv = false
                                clickmapdiv = false
                                clicklayerdiv = !clicklayerdiv
                            "
                        >
                            <el-image
                                style="
                                    width: 16px;
                                    height: 16px;
                                    line-height: 48px;
                                    top: 3px;
                                    right: 5px;
                                "
                                :src="
                                    clicklayerdiv
                                        ? '/static/images/图层管理-选中.png'
                                        : '/static/images/图层管理-未选中.png'
                                "
                            ></el-image
                            ><span
                                class="spantext"
                                :class="[clicklayerdiv ? 'clickspan' : '']"
                                >图层管理</span
                            >
                        </div>
                    </el-col>
                    <el-col
                        :span="8"
                        style="line-height: 48px; cursor: pointer"
                        :class="[clickmapdiv ? 'clickdiv' : '']"
                    >
                        <div
                            @click="
                                clickflag = false
                                clicklgenddiv = false
                                clicklayerdiv = false
                                clickmapdiv = !clickmapdiv
                            "
                        >
                            <el-image
                                style="
                                    width: 16px;
                                    height: 16px;
                                    line-height: 48px;
                                    top: 3px;
                                    right: 5px;
                                "
                                :src="
                                    clickmapdiv
                                        ? '/static/images/地图-未选中.png'
                                        : '/static/images/图例-未选中.png'
                                "
                            ></el-image
                            ><span
                                class="spantext"
                                :class="[clickmapdiv ? 'clickspan' : '']"
                                >地图</span
                            >
                        </div>
                    </el-col>
                </div></el-col
            >
            <el-col :span="4" style="margin-left: 10px"
                ><div
                    :class="[clickflag ? 'clicktruediv' : 'clickfalsediv']"
                    @click="
                        clicklgenddiv = false
                        clicklayerdiv = false
                        clickmapdiv = false
                        clickflag = !clickflag
                    "
                >
                    <span
                        :class="[
                            clickflag ? 'clicktruespan' : 'clickfalsespan',
                        ]"
                        >政区</span
                    >
                    <el-image
                        style="width: 12px; height: 8px"
                        :src="
                            clickflag
                                ? '/static/images/定位-箭头向上.png'
                                : '/static/images/定位箭头-向下.png'
                        "
                    ></el-image></div
            ></el-col>
        </el-row>
        <div
            v-if="clicklayerdiv"
            style="
                width: 293px;
                height: 350px;
                opacity: 0.85;
                background: #ffffff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
            "
        >
            <el-checkbox-group
                v-model="mapSwitcherSelects"
                @change="mapSwitcherChange"
                style="
                    text-align: left;
                    padding-top: 10px;
                    padding-left: 30px;
                    line-height: 20px;
                "
            >
                <el-checkbox
                    v-for="item in mapSwitcherSum"
                    :key="item"
                    style="margin: 0.5rem"
                    :label="item"
                    :value="item"
                >
                </el-checkbox>
            </el-checkbox-group>
        </div>
        <div
            v-if="clickmapdiv"
            style="
                width: 293px;
                height: 123px;
                opacity: 0.85;
                background: #ffffff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.12);
                border-radius: 0px 0px 4px 4px;
            "
        >
            <div
                style="
                    width: 90px;
                    height: 25px;
                    font-family: PingFangSC-Medium;
                    font-size: 18px;
                    color: #262626;
                    text-align: left;
                    font-weight: 550;
                    padding-top: 10px;
                    padding-left: 30px;
                "
            >
                底图类型：
            </div>
            <div
                style="
                    padding-top: 10px;
                    padding-left: 15px;
                    line-height: 45px;
                    height: 45px;
                "
            >
                <el-col :span="8">
                    <el-image
                        style="
                            width: 18px;
                            height: 18px;
                            top: 3px;
                            right: 5px;
                            cursor: pointer;
                        "
                        :src="
                            basemap == 'map'
                                ? '/static/images/单选框-选中.png'
                                : '/static/images/单选框-未选中.png'
                        "
                        @click="switchBaseMap('map')"
                    ></el-image
                    ><span :class="[basemap == 'map' ? 'basemaptext' : '']"
                        >地图</span
                    ></el-col
                >
                <el-col :span="8">
                    <el-image
                        style="
                            width: 18px;
                            height: 18px;
                            top: 3px;
                            right: 5px;
                            cursor: pointer;
                        "
                        :src="
                            basemap == 'image'
                                ? '/static/images/单选框-选中.png'
                                : '/static/images/单选框-未选中.png'
                        "
                        @click="switchBaseMap('image')"
                    ></el-image
                    ><span :class="[basemap == 'image' ? 'basemaptext' : '']"
                        >影像</span
                    ></el-col
                >
                <el-col :span="8">
                    <el-image
                        style="
                            width: 18px;
                            height: 18px;
                            top: 3px;
                            right: 5px;
                            cursor: pointer;
                        "
                        :src="
                            basemap == 'terrain'
                                ? '/static/images/单选框-选中.png'
                                : '/static/images/单选框-未选中.png'
                        "
                        @click="switchBaseMap('terrain')"
                    ></el-image
                    ><span :class="[basemap == 'terrain' ? 'basemaptext' : '']"
                        >地形</span
                    ></el-col
                >
            </div>
        </div>
        <div
            v-if="clickflag"
            style="
                width: 390px;
                opacity: 0.85;
                background: #ffffff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.12);
                border-radius: 0px 0px 4px 4px;
            "
        >
            <div class="menu" style="width: 100%; height: 100%">
                <el-card class="box-card" style="width: 100%; height: 100%">
                    <div
                        style="
                            text-align: left;
                            padding-top: 10px;
                            padding-left: 20px;
                            padding-right: 20px;
                        "
                    >
                        <el-row>
                            <el-input
                                placeholder="请输入聚落名称"
                                class="input-with-select"
                                v-model="juLuoKeyWord"
                                clearable
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    @click="searchJuLuo"
                                ></el-button>
                            </el-input>
                        </el-row>
                        <el-row style="margin-top: 0.5rem">
                            <span
                                v-if="searchTipFlag && juLuoKeyWord != ''"
                                style="color: red"
                                >你搜索的“{{ juLuoKeyWord }}”暂无结果。</span
                            >
                        </el-row>
                        <el-row>
                            <div style="height: 11rem; margin-top: 1rem">
                                <div class="side-title">府级政区：</div>
                                <div class="side-box">
                                    <el-button
                                        :type="
                                            item == highLightFuItem
                                                ? 'primary'
                                                : 'text'
                                        "
                                        :class="
                                            item.length > 4
                                                ? 'side-item adjust'
                                                : 'side-item '
                                        "
                                        v-for="(item, index) in fuData"
                                        v-bind:key="index"
                                        style="
                                            text-align: center;
                                            padding: 10px;
                                        "
                                        @click="changeCountry(item)"
                                    >
                                        {{ item }}
                                    </el-button>
                                </div>
                            </div>
                        </el-row>
                        <el-row>
                            <div style="min-height:6rem">
                                <div class="side-title">县级政区：</div>
                                <div class="side-box">
                                    <el-button
                                        :type="
                                            item == highLightCounterItem
                                                ? 'primary'
                                                : 'text'
                                        "
                                        :class="
                                            item.length > 4
                                                ? 'side-item  xianadjust'
                                                : 'side-item '
                                        "
                                        
                                        v-for="(item, index) in countryData"
                                        v-bind:key="index"
                                        style="
                                            text-align: center;
                                        "
                                        @click="changeCounty(item)"
                                    >
                                        {{ item }}
                                    </el-button>
                                </div>
                                <div style="height:10px"></div>
                            </div>
                        </el-row>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            clickflag: false,
            clicklgenddiv: false,
            clicklayerdiv: false,
            clickmapdiv: false,
            //图层控制总共有哪些图层
            mapSwitcherSum: [
                    '天地图底图',
                '1911年甘肃省级治所',
                '1911年甘肃府级治所',
                '1911年甘肃县级治所',
                '已定位聚落',
                '现代甘肃省级边界',
                '1911年甘肃省级边界',
                '1911年甘肃府级边界',
                '1911年甘肃县级边界',
            ],
            //图层控制选择了哪些图层
            mapSwitcherSelects: [
              '天地图底图',
                '1911年甘肃省级治所',
                '1911年甘肃府级治所',
                '1911年甘肃县级治所',
                '已定位聚落',
                '现代甘肃省级边界',
                '1911年甘肃省级边界',
                '1911年甘肃府级边界',
                '1911年甘肃县级边界',
            ],
            basemap: 'image',

            //data: [],
            // 厅县数据
            data: [],
            // 府数据 展示
            fuData: ["兰州府","平凉府","庆阳府","宁夏府","巩昌府","西宁府","凉州府","甘州府","肃州直隶州","泾州直隶州","固原州直隶州","化平川直隶厅","秦州直隶州","阶州直隶州","安西州直隶州"],
            // 当前选择的府数据
            highLightFuItem: '',
            // 县数据 展示
            countryData: [],
            highLightCounterItem: '',

            noSide: true,

            // 当前搜索聚落关键词
            juLuoKeyWord: '',
            searchTipFlag: false,
        }
    },
    watch: {
        juLuoKeyWord: {
            deep: true,
            handler(newVal, oldVal) {
                // if (newVal.trim().length !== 0) {
                //this.getList是methods中延迟后调用的方法 延迟500ms
                this.debounce(this.searchJuLuo, 500)
                // }
            },
        },
    },
    mounted() {
        this.getCountry()
    },
    methods: {
        sendBaseLayer(value) {
            this.$emit('sendBaseLayer', value)
        },
        layerControlDialog() {
            this.$emit('layerControlDialog')
        },
        displayLgend() {
            this.clickflag = false
            this.clicklayerdiv = false
            this.clickmapdiv = false
            this.clicklgenddiv = !this.clicklgenddiv
            this.$emit('displayLgend')
        },
        mapSwitcherChange(data, check) {
            this.$emit('leftTopMapSwitch', data)
        },
        switchBaseMap(value) {
            this.basemap = value
            this.$emit('sendBaseLayer', value)
        },

        //防抖
        debounce(fn, wait) {
            if (this.searchTimer !== null) {
                clearTimeout(this.searchTimer)
            }
            this.searchTimer = setTimeout(fn, wait)
        },
        // 获取厅县数据
        getCountry() {
            let temp = {}
            axios({
                url: $webConfig.V3.backendAPI+"getCountyNew",
                method: 'get',
                params: {
                },
            }).then((res) => {
                res.data.data.forEach((feature) => {
                    if(!(feature[0] in temp)){
                        temp[feature[0]] = [feature[1]]
                    }else{
                        temp[feature[0]].push(feature[1])
                    }
                })
                this.data = temp

        
            })
        },

        // 点击不同的府
        changeCountry(value) {
            this.highLightFuItem = value
            this.countryData = this.data[value]
        },
        // 点击县
        changeCounty(value) {
            this.highLightCounterItem = value
            this.$emit('zoomToCounty', value)
        },

        // 右侧 聚落搜索
        searchJuLuo() {
            let flag = true
            this.$parent.displayJuLuoLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    if (feature.getProperties().name == this.juLuoKeyWord) {
                        this.$emit('popInfo', feature.getProperties())
                        flag = false
                    }
                })
            if (flag) {
                this.searchTipFlag = true
            } else {
                this.searchTipFlag = false
            }
        },
    },
}
</script>
<style scoped>
.adjust {
    width: 104px !important;
}
.adjust1{
    font-size:12px;

}
.xianadjust{
    width:140px !important;
}
.left {
    position: relative;
}
.spantext {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #262626;
    text-align: left;
    font-weight: 550;
}
.clickdiv {
    background: #12c287;
}

.clickspan {
    color: #ffffff;
}
.clickfalsediv {
    width: 88px;
    height: 48px;
    opacity: 0.9;
    background: #ffffff;
    border-radius: 4px;
    cursor: pointer;
}
.clicktruediv {
    width: 88px;
    height: 48px;
    opacity: 0.9;
    cursor: pointer;
    background: #12c287;
    border-radius: 4px 4px 0px 0px;
}
.clickfalsespan {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #262626;
    text-align: left;
    line-height: 48px;
    font-weight: 550;
}
.clicktruespan {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #ffffff;
    text-align: left;
    line-height: 48px;
    font-weight: 550;
}
.basemaptext {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #000000;
    font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/V3/Main/Home/comLeftTopToolbox.vue